import { PROJECT_PROFILE } from "../constants/storageKeys";
import { debugLog } from "./debug";

export function SetBranding() {
  let projectProfile = window.localStorage.getItem(PROJECT_PROFILE);

  if (projectProfile === null) {
    return false;
  }

  debugLog("Setting custom branding");
  projectProfile = JSON.parse(projectProfile);
  const branding = projectProfile.branding;
  const cssContent = `
        button:disabled,
        button[disabled]{
        color: #605e5c;
        cursor: not-allowed;
        opacity: 0.5;
        }
        .text-brandPrimary {
            color: ${branding.colors.primary};
        }
        .img-brandLogo {
            display: block;
            width: 200px;
            margin: 0 auto;
        }
        .cancel-btn {
            color: ${branding.colors.primary};
        }
        .cancel-btn:hover {
            background-color: #A2A2A2;
            color: #FFFFFF;
        }
        .pill-selected, .program-selected, .value-selected, .primary-btn {
            color: ${branding.colors.text};
            background-color: ${branding.colors.primary};
        }
        .primary-btn:hover {
            color: #FFFFFF;
            background-color: #A2A2A2;
        }
        .loader {
            border-top-color: ${branding.colors.primary};
            -webkit-animation: spinner 1.5s linear infinite;
            animation: spinner 1.5s linear infinite;
        }
      `;
  const styleElement = document.createElement("style");
  styleElement.setAttribute("type", "text/css");
  styleElement.append(document.createTextNode(cssContent));
  document.head.appendChild(styleElement);

  return true;
}
